<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Work Calendar</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-1">
            <h4 class="mt-2">Company</h4>
          </div>
          <div class="col-md-5 fit-content">
            <select
              class="form-control"
              v-model="company"
              @change="changeCompany"
            >
              <option
                v-for="company in companies"
                :key="company.CompanyName"
                :value="company.CompanyName"
              >
                {{ company.CompanyName }}
              </option>
            </select>
          </div>
        </div>

        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
          <table
            style="width: auto !important"
            class="table table-bordered custom-table mb-0"
          >
            <thead class="thead-light">
              <tr>
                <th class="text-center" style="width: 300px">Calendar Code</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(wc, i) in workCalendars" :key="wc.Id">
                <td class="text-center" style="position: relative">
                  <input
                    type="text"
                    v-model="wc.CalendarCode"
                    class="form-control height26 text-center"
                    required
                  />
                  <span
                    @click="removeWorkCalendar(i)"
                    style="
                      position: absolute;
                      right: -8px;
                      top: 6px;
                      color: #ff0000;
                      cursor: pointer;
                    "
                  >
                    <i class="fa fa-minus-circle"></i>
                  </span>
                </td>
              </tr>

              <tr v-for="(newWc, i) in newWorkCalendars" :key="i">
                <td class="text-center" style="position: relative">
                  <input
                    type="text"
                    v-model="newWc.CalendarCode"
                    class="form-control height26 text-center"
                    required
                  />
                  <span
                    @click="removeNewWorkCalendar(i)"
                    style="
                      position: absolute;
                      right: -8px;
                      top: 6px;
                      color: #ff0000;
                      cursor: pointer;
                    "
                  >
                    <i class="fa fa-minus-circle"></i>
                  </span>
                </td>
              </tr>

              <tr>
                <td class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="addWorkCalendar"
                  >
                    <i class="fa fa-plus"></i> Add Calendar Code
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row mt-4">
          <div class="col-md-12">
            <button @click="save" type="button" class="btn btn-primary">
              <i class="fa fa-save"></i>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      company: "Lam Research Singapore Pte Ltd",
      companies: [],
      workCalendars: [],
      newWorkCalendars: [],
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },
  methods: {
    addWorkCalendar() {
      this.newWorkCalendars.push({
        Id: "",
        CalendarCode: "",
      });
    },
    removeNewWorkCalendar(index) {
      this.newWorkCalendars.splice(index, 1);
    },
    removeWorkCalendar(index) {
      this.workCalendars.splice(index, 1);
    },
    changeCompany() {
      this.getWorkCalendars();
    },
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
            this.company = this.companies[0].CompanyName;
            this.getWorkCalendars();
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getWorkCalendars() {
      let param = {
        Token: this.token,
        Company: this.company,
      };
      this.$store.state.isLoading = true;
      API.getWorkCalendars(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record) this.workCalendars = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      //check duplicate calendar code
      let allWorkCalendars = this.workCalendars.concat(this.newWorkCalendars);
      for (let item of allWorkCalendars) {
        if (item.CalendarCode) {
          let records = allWorkCalendars.filter(
            (c) => c.CalendarCode == item.CalendarCode
          );
          if (records && records.length > 1) {
            alert(`Calendar Code: ${item.CalendarCode} is duplicated.`);
            return;
          }
        }
      }

      let param = {
        Token: this.token,
        Company: this.company,
        WorkCalendars: this.workCalendars,
        NewWorkCalendars: this.newWorkCalendars,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the calendar code?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveWorkCalendar(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              this.workCalendars = [];
              this.newWorkCalendars = [];
              this.getWorkCalendars();
            })
            .catch((error) => {
              console.log(error);
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },
  created() {
    if (this.role != "admin") this.$router.replace({ name: "home" });
    this.getCompanies();
    this.getWorkCalendars();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/components/System/WorkCalendar.vue